import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import Button from 'containers/App/components/Button/Button';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'config/constants';

import dangerSign from '../../assets/images/danger-sign.png';
import close from '../../assets/images/general/close.svg';
import './SingpassResult.scss';

const DuplicateErrorContent = ({ onClose, onSignIn, onContactUs }) => (
    <>
        <div className='errorModal'>
            <button className='errorModal__close' onClick={onClose}>
                <img src={close} alt='Close' />
            </button>
            <div className='errorModal__logo'><img src={dangerSign} alt='Danger Sign' /></div>
            <div className='errorModal__text'>Singpass Already Connected</div>
            <div className='errorModal__instructions'>
                <p><span className='errorModal__instructions__bold'>Oops!</span> It seems your Singpass is already linked to a different email.</p>
                <ul>
                    <li>Please use the original email you have registered with Singpass.</li>
                    <li>We have sent an email to that account so you can easily find it in case you have forgotten.</li>
                    <li>If you no longer have access to that email or believe this is an error, please contact our <span className='errorModal__instructions__bold'>customer support</span> team for assistance.</li>
                </ul>
            </div>
        </div>
        <div className='errorModal__buttons'>
            <div className='errorModal__buttons__container'>
                <Button
                    className='contactUs'
                    onClick={onContactUs}
                    title='Contact Us' />
                <Button
                    className='signIn'
                    onClick={onSignIn}
                    title='Sign In' />
            </div>
        </div>
    </>
);

const GeneralErrorContent = ({ onClose }) => (
    <div className='errorModal'>
        <div className='errorModal__logo'><img src={dangerSign} alt='Danger Sign' /></div>
        <div className='errorModal__text'>
            We are not able to retrieve your information from Singpass.
        </div>
        <div>
            <Button
                className='submit'
                onClick={onClose}
                title='Proceed with your application' />
        </div>
    </div>
);

const SingpassErrorModal = ({ isOpen, onClose, errorType, onSignIn }) => {
    const history = useHistory();
    const isDuplicateError = errorType === 'duplicate';

    if (!isOpen) {
        return null;
    }

    return (
        <Modal
            isOpen={true}
            centered={true}
            className={isDuplicateError ? 'modalErrorDuplicate' : 'modalError'}
            toggle={onClose}>
            {isDuplicateError ? (
                <DuplicateErrorContent
                    onClose={onClose}
                    onSignIn={onSignIn}
                    onContactUs={() => history.push(ROUTES.CONTACT_US)} />
            ) : (
                <GeneralErrorContent onClose={onClose} />
            )}
        </Modal>
    );
};

DuplicateErrorContent.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSignIn: PropTypes.func.isRequired,
    onContactUs: PropTypes.func.isRequired
};

GeneralErrorContent.propTypes = {
    onClose: PropTypes.func.isRequired
};

SingpassErrorModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    errorType: PropTypes.oneOf(['duplicate', 'error']).isRequired,
    onSignIn: PropTypes.func.isRequired
};

export default SingpassErrorModal;
